/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrencyCode } from '../models/CurrencyCode';
import type { OptimizationEmployeeLeaving } from '../models/OptimizationEmployeeLeaving';
import type { OptimizationRightsizing } from '../models/OptimizationRightsizing';
import type { OptimizationSoftwareAccountDuplicate } from '../models/OptimizationSoftwareAccountDuplicate';
import type { OptimizationSoftwareAccountRedundantLicense } from '../models/OptimizationSoftwareAccountRedundantLicense';
import type { OptimizationSoftwareAccountUnused } from '../models/OptimizationSoftwareAccountUnused';
import type { OptimizationType } from '../models/OptimizationType';
import type { PaginationSortOrder } from '../models/PaginationSortOrder';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OptimizationsService {
    /**
     * Get Optimizations
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getOptimizationsApiV1ManagementOptimizationsGet({
        cached = false,
        hidden,
        tagsExists,
        tagsEq,
        tagsGt,
        tagsGte,
        tagsIn,
        tagsLt,
        tagsLte,
        tagsNe,
        tagsNin,
        tagsAll,
        tagsSize,
        tags,
        createdExists,
        createdEq,
        createdGt,
        createdGte,
        createdIn,
        createdLt,
        createdLte,
        createdNe,
        createdNin,
        created,
        updatedExists,
        updatedEq,
        updatedGt,
        updatedGte,
        updatedIn,
        updatedLt,
        updatedLte,
        updatedNe,
        updatedNin,
        updated,
        deleted,
        deletedAtExists,
        deletedAtEq,
        deletedAtGt,
        deletedAtGte,
        deletedAtIn,
        deletedAtLt,
        deletedAtLte,
        deletedAtNe,
        deletedAtNin,
        deletedAt,
        includeDeleted = false,
        idExists,
        idEq,
        idGt,
        idGte,
        idIn,
        idLt,
        idLte,
        idNe,
        idNin,
        id,
        typeExists,
        typeEq,
        typeGt,
        typeGte,
        typeIn,
        typeLt,
        typeLte,
        typeNe,
        typeNin,
        type,
        deprecated,
        referencesAccountIdExists,
        referencesAccountIdEq,
        referencesAccountIdGt,
        referencesAccountIdGte,
        referencesAccountIdIn,
        referencesAccountIdLt,
        referencesAccountIdLte,
        referencesAccountIdNe,
        referencesAccountIdNin,
        referencesAccountId,
        referencesDataSourceIdExists,
        referencesDataSourceIdEq,
        referencesDataSourceIdGt,
        referencesDataSourceIdGte,
        referencesDataSourceIdIn,
        referencesDataSourceIdLt,
        referencesDataSourceIdLte,
        referencesDataSourceIdNe,
        referencesDataSourceIdNin,
        referencesDataSourceId,
        referencesEmployeeIdExists,
        referencesEmployeeIdEq,
        referencesEmployeeIdGt,
        referencesEmployeeIdGte,
        referencesEmployeeIdIn,
        referencesEmployeeIdLt,
        referencesEmployeeIdLte,
        referencesEmployeeIdNe,
        referencesEmployeeIdNin,
        referencesEmployeeId,
        referencesSoftwareAccountIdExists,
        referencesSoftwareAccountIdEq,
        referencesSoftwareAccountIdGt,
        referencesSoftwareAccountIdGte,
        referencesSoftwareAccountIdIn,
        referencesSoftwareAccountIdLt,
        referencesSoftwareAccountIdLte,
        referencesSoftwareAccountIdNe,
        referencesSoftwareAccountIdNin,
        referencesSoftwareAccountId,
        referencesSoftwareAccountIdsExists,
        referencesSoftwareAccountIdsEq,
        referencesSoftwareAccountIdsGt,
        referencesSoftwareAccountIdsGte,
        referencesSoftwareAccountIdsIn,
        referencesSoftwareAccountIdsLt,
        referencesSoftwareAccountIdsLte,
        referencesSoftwareAccountIdsNe,
        referencesSoftwareAccountIdsNin,
        referencesSoftwareAccountIdsAll,
        referencesSoftwareAccountIdsSize,
        referencesSoftwareAccountIds,
        referencesSoftwareIdExists,
        referencesSoftwareIdEq,
        referencesSoftwareIdGt,
        referencesSoftwareIdGte,
        referencesSoftwareIdIn,
        referencesSoftwareIdLt,
        referencesSoftwareIdLte,
        referencesSoftwareIdNe,
        referencesSoftwareIdNin,
        referencesSoftwareId,
        referencesSubAccountIdExists,
        referencesSubAccountIdEq,
        referencesSubAccountIdGt,
        referencesSubAccountIdGte,
        referencesSubAccountIdIn,
        referencesSubAccountIdLt,
        referencesSubAccountIdLte,
        referencesSubAccountIdNe,
        referencesSubAccountIdNin,
        referencesSubAccountId,
        references,
        limit,
        offset,
        sortBy,
        sortOrder,
        sort,
        xTransactionId,
    }: {
        cached?: boolean,
        hidden?: (boolean | null),
        tagsExists?: (boolean | null),
        tagsEq?: (string | null),
        tagsGt?: (string | null),
        tagsGte?: (string | null),
        tagsIn?: (Array<string> | null),
        tagsLt?: (string | null),
        tagsLte?: (string | null),
        tagsNe?: (string | null),
        tagsNin?: (Array<string> | null),
        tagsAll?: (Array<string> | null),
        tagsSize?: (number | null),
        tags?: (string | null),
        createdExists?: (boolean | null),
        createdEq?: (string | null),
        createdGt?: (string | null),
        createdGte?: (string | null),
        createdIn?: (Array<string> | null),
        createdLt?: (string | null),
        createdLte?: (string | null),
        createdNe?: (string | null),
        createdNin?: (Array<string> | null),
        created?: (string | null),
        updatedExists?: (boolean | null),
        updatedEq?: (string | null),
        updatedGt?: (string | null),
        updatedGte?: (string | null),
        updatedIn?: (Array<string> | null),
        updatedLt?: (string | null),
        updatedLte?: (string | null),
        updatedNe?: (string | null),
        updatedNin?: (Array<string> | null),
        updated?: (string | null),
        deleted?: (boolean | null),
        deletedAtExists?: (boolean | null),
        deletedAtEq?: (string | null),
        deletedAtGt?: (string | null),
        deletedAtGte?: (string | null),
        deletedAtIn?: (Array<string> | null),
        deletedAtLt?: (string | null),
        deletedAtLte?: (string | null),
        deletedAtNe?: (string | null),
        deletedAtNin?: (Array<string> | null),
        deletedAt?: (string | null),
        includeDeleted?: boolean,
        idExists?: (boolean | null),
        idEq?: (string | null),
        idGt?: (string | null),
        idGte?: (string | null),
        idIn?: (Array<string> | null),
        idLt?: (string | null),
        idLte?: (string | null),
        idNe?: (string | null),
        idNin?: (Array<string> | null),
        id?: (string | null),
        typeExists?: (boolean | null),
        typeEq?: (OptimizationType | null),
        typeGt?: (OptimizationType | null),
        typeGte?: (OptimizationType | null),
        typeIn?: (Array<OptimizationType> | null),
        typeLt?: (OptimizationType | null),
        typeLte?: (OptimizationType | null),
        typeNe?: (OptimizationType | null),
        typeNin?: (Array<OptimizationType> | null),
        type?: (OptimizationType | null),
        deprecated?: (boolean | null),
        referencesAccountIdExists?: (boolean | null),
        referencesAccountIdEq?: (string | null),
        referencesAccountIdGt?: (string | null),
        referencesAccountIdGte?: (string | null),
        referencesAccountIdIn?: (Array<string> | null),
        referencesAccountIdLt?: (string | null),
        referencesAccountIdLte?: (string | null),
        referencesAccountIdNe?: (string | null),
        referencesAccountIdNin?: (Array<string> | null),
        referencesAccountId?: (string | null),
        referencesDataSourceIdExists?: (boolean | null),
        referencesDataSourceIdEq?: (string | null),
        referencesDataSourceIdGt?: (string | null),
        referencesDataSourceIdGte?: (string | null),
        referencesDataSourceIdIn?: (Array<string> | null),
        referencesDataSourceIdLt?: (string | null),
        referencesDataSourceIdLte?: (string | null),
        referencesDataSourceIdNe?: (string | null),
        referencesDataSourceIdNin?: (Array<string> | null),
        referencesDataSourceId?: (string | null),
        referencesEmployeeIdExists?: (boolean | null),
        referencesEmployeeIdEq?: (string | null),
        referencesEmployeeIdGt?: (string | null),
        referencesEmployeeIdGte?: (string | null),
        referencesEmployeeIdIn?: (Array<string> | null),
        referencesEmployeeIdLt?: (string | null),
        referencesEmployeeIdLte?: (string | null),
        referencesEmployeeIdNe?: (string | null),
        referencesEmployeeIdNin?: (Array<string> | null),
        referencesEmployeeId?: (string | null),
        referencesSoftwareAccountIdExists?: (boolean | null),
        referencesSoftwareAccountIdEq?: (string | null),
        referencesSoftwareAccountIdGt?: (string | null),
        referencesSoftwareAccountIdGte?: (string | null),
        referencesSoftwareAccountIdIn?: (Array<string> | null),
        referencesSoftwareAccountIdLt?: (string | null),
        referencesSoftwareAccountIdLte?: (string | null),
        referencesSoftwareAccountIdNe?: (string | null),
        referencesSoftwareAccountIdNin?: (Array<string> | null),
        referencesSoftwareAccountId?: (string | null),
        referencesSoftwareAccountIdsExists?: (boolean | null),
        referencesSoftwareAccountIdsEq?: (string | null),
        referencesSoftwareAccountIdsGt?: (string | null),
        referencesSoftwareAccountIdsGte?: (string | null),
        referencesSoftwareAccountIdsIn?: (Array<string> | null),
        referencesSoftwareAccountIdsLt?: (string | null),
        referencesSoftwareAccountIdsLte?: (string | null),
        referencesSoftwareAccountIdsNe?: (string | null),
        referencesSoftwareAccountIdsNin?: (Array<string> | null),
        referencesSoftwareAccountIdsAll?: (Array<string> | null),
        referencesSoftwareAccountIdsSize?: (number | null),
        referencesSoftwareAccountIds?: (string | null),
        referencesSoftwareIdExists?: (boolean | null),
        referencesSoftwareIdEq?: (string | null),
        referencesSoftwareIdGt?: (string | null),
        referencesSoftwareIdGte?: (string | null),
        referencesSoftwareIdIn?: (Array<string> | null),
        referencesSoftwareIdLt?: (string | null),
        referencesSoftwareIdLte?: (string | null),
        referencesSoftwareIdNe?: (string | null),
        referencesSoftwareIdNin?: (Array<string> | null),
        referencesSoftwareId?: (string | null),
        referencesSubAccountIdExists?: (boolean | null),
        referencesSubAccountIdEq?: (string | null),
        referencesSubAccountIdGt?: (string | null),
        referencesSubAccountIdGte?: (string | null),
        referencesSubAccountIdIn?: (Array<string> | null),
        referencesSubAccountIdLt?: (string | null),
        referencesSubAccountIdLte?: (string | null),
        referencesSubAccountIdNe?: (string | null),
        referencesSubAccountIdNin?: (Array<string> | null),
        referencesSubAccountId?: (string | null),
        references?: null,
        limit?: (number | null),
        offset?: (number | null),
        /**
         * Field name to be sorted by. Ignored if 'sort' is specified
         */
        sortBy?: (string | null),
        /**
         * Sort order to be sorted by. Ignored if 'sort' is specified
         */
        sortOrder?: (PaginationSortOrder | null),
        /**
         * Sort field in the form `<field_name>:<sort_by>`. Example: `sort=email:asc`. If at least one is set, sort_by and sort_order are ignored
         */
        sort?: (Array<string> | null),
        xTransactionId?: (string | null),
    }): CancelablePromise<Array<(OptimizationEmployeeLeaving | OptimizationSoftwareAccountDuplicate | OptimizationSoftwareAccountRedundantLicense | OptimizationSoftwareAccountUnused | OptimizationRightsizing)>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/management/optimizations',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'cached': cached,
                'hidden': hidden,
                'tags.$exists': tagsExists,
                'tags.$eq': tagsEq,
                'tags.$gt': tagsGt,
                'tags.$gte': tagsGte,
                'tags.$in': tagsIn,
                'tags.$lt': tagsLt,
                'tags.$lte': tagsLte,
                'tags.$ne': tagsNe,
                'tags.$nin': tagsNin,
                'tags.$all': tagsAll,
                'tags.$size': tagsSize,
                'tags': tags,
                'created.$exists': createdExists,
                'created.$eq': createdEq,
                'created.$gt': createdGt,
                'created.$gte': createdGte,
                'created.$in': createdIn,
                'created.$lt': createdLt,
                'created.$lte': createdLte,
                'created.$ne': createdNe,
                'created.$nin': createdNin,
                'created': created,
                'updated.$exists': updatedExists,
                'updated.$eq': updatedEq,
                'updated.$gt': updatedGt,
                'updated.$gte': updatedGte,
                'updated.$in': updatedIn,
                'updated.$lt': updatedLt,
                'updated.$lte': updatedLte,
                'updated.$ne': updatedNe,
                'updated.$nin': updatedNin,
                'updated': updated,
                'deleted': deleted,
                'deleted_at.$exists': deletedAtExists,
                'deleted_at.$eq': deletedAtEq,
                'deleted_at.$gt': deletedAtGt,
                'deleted_at.$gte': deletedAtGte,
                'deleted_at.$in': deletedAtIn,
                'deleted_at.$lt': deletedAtLt,
                'deleted_at.$lte': deletedAtLte,
                'deleted_at.$ne': deletedAtNe,
                'deleted_at.$nin': deletedAtNin,
                'deleted_at': deletedAt,
                'include_deleted': includeDeleted,
                '_id.$exists': idExists,
                '_id.$eq': idEq,
                '_id.$gt': idGt,
                '_id.$gte': idGte,
                '_id.$in': idIn,
                '_id.$lt': idLt,
                '_id.$lte': idLte,
                '_id.$ne': idNe,
                '_id.$nin': idNin,
                '_id': id,
                'type.$exists': typeExists,
                'type.$eq': typeEq,
                'type.$gt': typeGt,
                'type.$gte': typeGte,
                'type.$in': typeIn,
                'type.$lt': typeLt,
                'type.$lte': typeLte,
                'type.$ne': typeNe,
                'type.$nin': typeNin,
                'type': type,
                'deprecated': deprecated,
                'references.account_id.$exists': referencesAccountIdExists,
                'references.account_id.$eq': referencesAccountIdEq,
                'references.account_id.$gt': referencesAccountIdGt,
                'references.account_id.$gte': referencesAccountIdGte,
                'references.account_id.$in': referencesAccountIdIn,
                'references.account_id.$lt': referencesAccountIdLt,
                'references.account_id.$lte': referencesAccountIdLte,
                'references.account_id.$ne': referencesAccountIdNe,
                'references.account_id.$nin': referencesAccountIdNin,
                'references.account_id': referencesAccountId,
                'references.data_source_id.$exists': referencesDataSourceIdExists,
                'references.data_source_id.$eq': referencesDataSourceIdEq,
                'references.data_source_id.$gt': referencesDataSourceIdGt,
                'references.data_source_id.$gte': referencesDataSourceIdGte,
                'references.data_source_id.$in': referencesDataSourceIdIn,
                'references.data_source_id.$lt': referencesDataSourceIdLt,
                'references.data_source_id.$lte': referencesDataSourceIdLte,
                'references.data_source_id.$ne': referencesDataSourceIdNe,
                'references.data_source_id.$nin': referencesDataSourceIdNin,
                'references.data_source_id': referencesDataSourceId,
                'references.employee_id.$exists': referencesEmployeeIdExists,
                'references.employee_id.$eq': referencesEmployeeIdEq,
                'references.employee_id.$gt': referencesEmployeeIdGt,
                'references.employee_id.$gte': referencesEmployeeIdGte,
                'references.employee_id.$in': referencesEmployeeIdIn,
                'references.employee_id.$lt': referencesEmployeeIdLt,
                'references.employee_id.$lte': referencesEmployeeIdLte,
                'references.employee_id.$ne': referencesEmployeeIdNe,
                'references.employee_id.$nin': referencesEmployeeIdNin,
                'references.employee_id': referencesEmployeeId,
                'references.software_account_id.$exists': referencesSoftwareAccountIdExists,
                'references.software_account_id.$eq': referencesSoftwareAccountIdEq,
                'references.software_account_id.$gt': referencesSoftwareAccountIdGt,
                'references.software_account_id.$gte': referencesSoftwareAccountIdGte,
                'references.software_account_id.$in': referencesSoftwareAccountIdIn,
                'references.software_account_id.$lt': referencesSoftwareAccountIdLt,
                'references.software_account_id.$lte': referencesSoftwareAccountIdLte,
                'references.software_account_id.$ne': referencesSoftwareAccountIdNe,
                'references.software_account_id.$nin': referencesSoftwareAccountIdNin,
                'references.software_account_id': referencesSoftwareAccountId,
                'references.software_account_ids.$exists': referencesSoftwareAccountIdsExists,
                'references.software_account_ids.$eq': referencesSoftwareAccountIdsEq,
                'references.software_account_ids.$gt': referencesSoftwareAccountIdsGt,
                'references.software_account_ids.$gte': referencesSoftwareAccountIdsGte,
                'references.software_account_ids.$in': referencesSoftwareAccountIdsIn,
                'references.software_account_ids.$lt': referencesSoftwareAccountIdsLt,
                'references.software_account_ids.$lte': referencesSoftwareAccountIdsLte,
                'references.software_account_ids.$ne': referencesSoftwareAccountIdsNe,
                'references.software_account_ids.$nin': referencesSoftwareAccountIdsNin,
                'references.software_account_ids.$all': referencesSoftwareAccountIdsAll,
                'references.software_account_ids.$size': referencesSoftwareAccountIdsSize,
                'references.software_account_ids': referencesSoftwareAccountIds,
                'references.software_id.$exists': referencesSoftwareIdExists,
                'references.software_id.$eq': referencesSoftwareIdEq,
                'references.software_id.$gt': referencesSoftwareIdGt,
                'references.software_id.$gte': referencesSoftwareIdGte,
                'references.software_id.$in': referencesSoftwareIdIn,
                'references.software_id.$lt': referencesSoftwareIdLt,
                'references.software_id.$lte': referencesSoftwareIdLte,
                'references.software_id.$ne': referencesSoftwareIdNe,
                'references.software_id.$nin': referencesSoftwareIdNin,
                'references.software_id': referencesSoftwareId,
                'references.sub_account_id.$exists': referencesSubAccountIdExists,
                'references.sub_account_id.$eq': referencesSubAccountIdEq,
                'references.sub_account_id.$gt': referencesSubAccountIdGt,
                'references.sub_account_id.$gte': referencesSubAccountIdGte,
                'references.sub_account_id.$in': referencesSubAccountIdIn,
                'references.sub_account_id.$lt': referencesSubAccountIdLt,
                'references.sub_account_id.$lte': referencesSubAccountIdLte,
                'references.sub_account_id.$ne': referencesSubAccountIdNe,
                'references.sub_account_id.$nin': referencesSubAccountIdNin,
                'references.sub_account_id': referencesSubAccountId,
                'references': references,
                'limit': limit,
                'offset': offset,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'sort': sort,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Count Optimizations
     * @returns number Successful Response
     * @throws ApiError
     */
    public static countOptimizationsApiV1ManagementOptimizationsCountGet({
        hidden,
        tagsExists,
        tagsEq,
        tagsGt,
        tagsGte,
        tagsIn,
        tagsLt,
        tagsLte,
        tagsNe,
        tagsNin,
        tagsAll,
        tagsSize,
        tags,
        createdExists,
        createdEq,
        createdGt,
        createdGte,
        createdIn,
        createdLt,
        createdLte,
        createdNe,
        createdNin,
        created,
        updatedExists,
        updatedEq,
        updatedGt,
        updatedGte,
        updatedIn,
        updatedLt,
        updatedLte,
        updatedNe,
        updatedNin,
        updated,
        deleted,
        deletedAtExists,
        deletedAtEq,
        deletedAtGt,
        deletedAtGte,
        deletedAtIn,
        deletedAtLt,
        deletedAtLte,
        deletedAtNe,
        deletedAtNin,
        deletedAt,
        includeDeleted = false,
        idExists,
        idEq,
        idGt,
        idGte,
        idIn,
        idLt,
        idLte,
        idNe,
        idNin,
        id,
        typeExists,
        typeEq,
        typeGt,
        typeGte,
        typeIn,
        typeLt,
        typeLte,
        typeNe,
        typeNin,
        type,
        deprecated,
        referencesAccountIdExists,
        referencesAccountIdEq,
        referencesAccountIdGt,
        referencesAccountIdGte,
        referencesAccountIdIn,
        referencesAccountIdLt,
        referencesAccountIdLte,
        referencesAccountIdNe,
        referencesAccountIdNin,
        referencesAccountId,
        referencesDataSourceIdExists,
        referencesDataSourceIdEq,
        referencesDataSourceIdGt,
        referencesDataSourceIdGte,
        referencesDataSourceIdIn,
        referencesDataSourceIdLt,
        referencesDataSourceIdLte,
        referencesDataSourceIdNe,
        referencesDataSourceIdNin,
        referencesDataSourceId,
        referencesEmployeeIdExists,
        referencesEmployeeIdEq,
        referencesEmployeeIdGt,
        referencesEmployeeIdGte,
        referencesEmployeeIdIn,
        referencesEmployeeIdLt,
        referencesEmployeeIdLte,
        referencesEmployeeIdNe,
        referencesEmployeeIdNin,
        referencesEmployeeId,
        referencesSoftwareAccountIdExists,
        referencesSoftwareAccountIdEq,
        referencesSoftwareAccountIdGt,
        referencesSoftwareAccountIdGte,
        referencesSoftwareAccountIdIn,
        referencesSoftwareAccountIdLt,
        referencesSoftwareAccountIdLte,
        referencesSoftwareAccountIdNe,
        referencesSoftwareAccountIdNin,
        referencesSoftwareAccountId,
        referencesSoftwareAccountIdsExists,
        referencesSoftwareAccountIdsEq,
        referencesSoftwareAccountIdsGt,
        referencesSoftwareAccountIdsGte,
        referencesSoftwareAccountIdsIn,
        referencesSoftwareAccountIdsLt,
        referencesSoftwareAccountIdsLte,
        referencesSoftwareAccountIdsNe,
        referencesSoftwareAccountIdsNin,
        referencesSoftwareAccountIdsAll,
        referencesSoftwareAccountIdsSize,
        referencesSoftwareAccountIds,
        referencesSoftwareIdExists,
        referencesSoftwareIdEq,
        referencesSoftwareIdGt,
        referencesSoftwareIdGte,
        referencesSoftwareIdIn,
        referencesSoftwareIdLt,
        referencesSoftwareIdLte,
        referencesSoftwareIdNe,
        referencesSoftwareIdNin,
        referencesSoftwareId,
        referencesSubAccountIdExists,
        referencesSubAccountIdEq,
        referencesSubAccountIdGt,
        referencesSubAccountIdGte,
        referencesSubAccountIdIn,
        referencesSubAccountIdLt,
        referencesSubAccountIdLte,
        referencesSubAccountIdNe,
        referencesSubAccountIdNin,
        referencesSubAccountId,
        references,
        xTransactionId,
    }: {
        hidden?: (boolean | null),
        tagsExists?: (boolean | null),
        tagsEq?: (string | null),
        tagsGt?: (string | null),
        tagsGte?: (string | null),
        tagsIn?: (Array<string> | null),
        tagsLt?: (string | null),
        tagsLte?: (string | null),
        tagsNe?: (string | null),
        tagsNin?: (Array<string> | null),
        tagsAll?: (Array<string> | null),
        tagsSize?: (number | null),
        tags?: (string | null),
        createdExists?: (boolean | null),
        createdEq?: (string | null),
        createdGt?: (string | null),
        createdGte?: (string | null),
        createdIn?: (Array<string> | null),
        createdLt?: (string | null),
        createdLte?: (string | null),
        createdNe?: (string | null),
        createdNin?: (Array<string> | null),
        created?: (string | null),
        updatedExists?: (boolean | null),
        updatedEq?: (string | null),
        updatedGt?: (string | null),
        updatedGte?: (string | null),
        updatedIn?: (Array<string> | null),
        updatedLt?: (string | null),
        updatedLte?: (string | null),
        updatedNe?: (string | null),
        updatedNin?: (Array<string> | null),
        updated?: (string | null),
        deleted?: (boolean | null),
        deletedAtExists?: (boolean | null),
        deletedAtEq?: (string | null),
        deletedAtGt?: (string | null),
        deletedAtGte?: (string | null),
        deletedAtIn?: (Array<string> | null),
        deletedAtLt?: (string | null),
        deletedAtLte?: (string | null),
        deletedAtNe?: (string | null),
        deletedAtNin?: (Array<string> | null),
        deletedAt?: (string | null),
        includeDeleted?: boolean,
        idExists?: (boolean | null),
        idEq?: (string | null),
        idGt?: (string | null),
        idGte?: (string | null),
        idIn?: (Array<string> | null),
        idLt?: (string | null),
        idLte?: (string | null),
        idNe?: (string | null),
        idNin?: (Array<string> | null),
        id?: (string | null),
        typeExists?: (boolean | null),
        typeEq?: (OptimizationType | null),
        typeGt?: (OptimizationType | null),
        typeGte?: (OptimizationType | null),
        typeIn?: (Array<OptimizationType> | null),
        typeLt?: (OptimizationType | null),
        typeLte?: (OptimizationType | null),
        typeNe?: (OptimizationType | null),
        typeNin?: (Array<OptimizationType> | null),
        type?: (OptimizationType | null),
        deprecated?: (boolean | null),
        referencesAccountIdExists?: (boolean | null),
        referencesAccountIdEq?: (string | null),
        referencesAccountIdGt?: (string | null),
        referencesAccountIdGte?: (string | null),
        referencesAccountIdIn?: (Array<string> | null),
        referencesAccountIdLt?: (string | null),
        referencesAccountIdLte?: (string | null),
        referencesAccountIdNe?: (string | null),
        referencesAccountIdNin?: (Array<string> | null),
        referencesAccountId?: (string | null),
        referencesDataSourceIdExists?: (boolean | null),
        referencesDataSourceIdEq?: (string | null),
        referencesDataSourceIdGt?: (string | null),
        referencesDataSourceIdGte?: (string | null),
        referencesDataSourceIdIn?: (Array<string> | null),
        referencesDataSourceIdLt?: (string | null),
        referencesDataSourceIdLte?: (string | null),
        referencesDataSourceIdNe?: (string | null),
        referencesDataSourceIdNin?: (Array<string> | null),
        referencesDataSourceId?: (string | null),
        referencesEmployeeIdExists?: (boolean | null),
        referencesEmployeeIdEq?: (string | null),
        referencesEmployeeIdGt?: (string | null),
        referencesEmployeeIdGte?: (string | null),
        referencesEmployeeIdIn?: (Array<string> | null),
        referencesEmployeeIdLt?: (string | null),
        referencesEmployeeIdLte?: (string | null),
        referencesEmployeeIdNe?: (string | null),
        referencesEmployeeIdNin?: (Array<string> | null),
        referencesEmployeeId?: (string | null),
        referencesSoftwareAccountIdExists?: (boolean | null),
        referencesSoftwareAccountIdEq?: (string | null),
        referencesSoftwareAccountIdGt?: (string | null),
        referencesSoftwareAccountIdGte?: (string | null),
        referencesSoftwareAccountIdIn?: (Array<string> | null),
        referencesSoftwareAccountIdLt?: (string | null),
        referencesSoftwareAccountIdLte?: (string | null),
        referencesSoftwareAccountIdNe?: (string | null),
        referencesSoftwareAccountIdNin?: (Array<string> | null),
        referencesSoftwareAccountId?: (string | null),
        referencesSoftwareAccountIdsExists?: (boolean | null),
        referencesSoftwareAccountIdsEq?: (string | null),
        referencesSoftwareAccountIdsGt?: (string | null),
        referencesSoftwareAccountIdsGte?: (string | null),
        referencesSoftwareAccountIdsIn?: (Array<string> | null),
        referencesSoftwareAccountIdsLt?: (string | null),
        referencesSoftwareAccountIdsLte?: (string | null),
        referencesSoftwareAccountIdsNe?: (string | null),
        referencesSoftwareAccountIdsNin?: (Array<string> | null),
        referencesSoftwareAccountIdsAll?: (Array<string> | null),
        referencesSoftwareAccountIdsSize?: (number | null),
        referencesSoftwareAccountIds?: (string | null),
        referencesSoftwareIdExists?: (boolean | null),
        referencesSoftwareIdEq?: (string | null),
        referencesSoftwareIdGt?: (string | null),
        referencesSoftwareIdGte?: (string | null),
        referencesSoftwareIdIn?: (Array<string> | null),
        referencesSoftwareIdLt?: (string | null),
        referencesSoftwareIdLte?: (string | null),
        referencesSoftwareIdNe?: (string | null),
        referencesSoftwareIdNin?: (Array<string> | null),
        referencesSoftwareId?: (string | null),
        referencesSubAccountIdExists?: (boolean | null),
        referencesSubAccountIdEq?: (string | null),
        referencesSubAccountIdGt?: (string | null),
        referencesSubAccountIdGte?: (string | null),
        referencesSubAccountIdIn?: (Array<string> | null),
        referencesSubAccountIdLt?: (string | null),
        referencesSubAccountIdLte?: (string | null),
        referencesSubAccountIdNe?: (string | null),
        referencesSubAccountIdNin?: (Array<string> | null),
        referencesSubAccountId?: (string | null),
        references?: null,
        xTransactionId?: (string | null),
    }): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/management/optimizations/count',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'hidden': hidden,
                'tags.$exists': tagsExists,
                'tags.$eq': tagsEq,
                'tags.$gt': tagsGt,
                'tags.$gte': tagsGte,
                'tags.$in': tagsIn,
                'tags.$lt': tagsLt,
                'tags.$lte': tagsLte,
                'tags.$ne': tagsNe,
                'tags.$nin': tagsNin,
                'tags.$all': tagsAll,
                'tags.$size': tagsSize,
                'tags': tags,
                'created.$exists': createdExists,
                'created.$eq': createdEq,
                'created.$gt': createdGt,
                'created.$gte': createdGte,
                'created.$in': createdIn,
                'created.$lt': createdLt,
                'created.$lte': createdLte,
                'created.$ne': createdNe,
                'created.$nin': createdNin,
                'created': created,
                'updated.$exists': updatedExists,
                'updated.$eq': updatedEq,
                'updated.$gt': updatedGt,
                'updated.$gte': updatedGte,
                'updated.$in': updatedIn,
                'updated.$lt': updatedLt,
                'updated.$lte': updatedLte,
                'updated.$ne': updatedNe,
                'updated.$nin': updatedNin,
                'updated': updated,
                'deleted': deleted,
                'deleted_at.$exists': deletedAtExists,
                'deleted_at.$eq': deletedAtEq,
                'deleted_at.$gt': deletedAtGt,
                'deleted_at.$gte': deletedAtGte,
                'deleted_at.$in': deletedAtIn,
                'deleted_at.$lt': deletedAtLt,
                'deleted_at.$lte': deletedAtLte,
                'deleted_at.$ne': deletedAtNe,
                'deleted_at.$nin': deletedAtNin,
                'deleted_at': deletedAt,
                'include_deleted': includeDeleted,
                '_id.$exists': idExists,
                '_id.$eq': idEq,
                '_id.$gt': idGt,
                '_id.$gte': idGte,
                '_id.$in': idIn,
                '_id.$lt': idLt,
                '_id.$lte': idLte,
                '_id.$ne': idNe,
                '_id.$nin': idNin,
                '_id': id,
                'type.$exists': typeExists,
                'type.$eq': typeEq,
                'type.$gt': typeGt,
                'type.$gte': typeGte,
                'type.$in': typeIn,
                'type.$lt': typeLt,
                'type.$lte': typeLte,
                'type.$ne': typeNe,
                'type.$nin': typeNin,
                'type': type,
                'deprecated': deprecated,
                'references.account_id.$exists': referencesAccountIdExists,
                'references.account_id.$eq': referencesAccountIdEq,
                'references.account_id.$gt': referencesAccountIdGt,
                'references.account_id.$gte': referencesAccountIdGte,
                'references.account_id.$in': referencesAccountIdIn,
                'references.account_id.$lt': referencesAccountIdLt,
                'references.account_id.$lte': referencesAccountIdLte,
                'references.account_id.$ne': referencesAccountIdNe,
                'references.account_id.$nin': referencesAccountIdNin,
                'references.account_id': referencesAccountId,
                'references.data_source_id.$exists': referencesDataSourceIdExists,
                'references.data_source_id.$eq': referencesDataSourceIdEq,
                'references.data_source_id.$gt': referencesDataSourceIdGt,
                'references.data_source_id.$gte': referencesDataSourceIdGte,
                'references.data_source_id.$in': referencesDataSourceIdIn,
                'references.data_source_id.$lt': referencesDataSourceIdLt,
                'references.data_source_id.$lte': referencesDataSourceIdLte,
                'references.data_source_id.$ne': referencesDataSourceIdNe,
                'references.data_source_id.$nin': referencesDataSourceIdNin,
                'references.data_source_id': referencesDataSourceId,
                'references.employee_id.$exists': referencesEmployeeIdExists,
                'references.employee_id.$eq': referencesEmployeeIdEq,
                'references.employee_id.$gt': referencesEmployeeIdGt,
                'references.employee_id.$gte': referencesEmployeeIdGte,
                'references.employee_id.$in': referencesEmployeeIdIn,
                'references.employee_id.$lt': referencesEmployeeIdLt,
                'references.employee_id.$lte': referencesEmployeeIdLte,
                'references.employee_id.$ne': referencesEmployeeIdNe,
                'references.employee_id.$nin': referencesEmployeeIdNin,
                'references.employee_id': referencesEmployeeId,
                'references.software_account_id.$exists': referencesSoftwareAccountIdExists,
                'references.software_account_id.$eq': referencesSoftwareAccountIdEq,
                'references.software_account_id.$gt': referencesSoftwareAccountIdGt,
                'references.software_account_id.$gte': referencesSoftwareAccountIdGte,
                'references.software_account_id.$in': referencesSoftwareAccountIdIn,
                'references.software_account_id.$lt': referencesSoftwareAccountIdLt,
                'references.software_account_id.$lte': referencesSoftwareAccountIdLte,
                'references.software_account_id.$ne': referencesSoftwareAccountIdNe,
                'references.software_account_id.$nin': referencesSoftwareAccountIdNin,
                'references.software_account_id': referencesSoftwareAccountId,
                'references.software_account_ids.$exists': referencesSoftwareAccountIdsExists,
                'references.software_account_ids.$eq': referencesSoftwareAccountIdsEq,
                'references.software_account_ids.$gt': referencesSoftwareAccountIdsGt,
                'references.software_account_ids.$gte': referencesSoftwareAccountIdsGte,
                'references.software_account_ids.$in': referencesSoftwareAccountIdsIn,
                'references.software_account_ids.$lt': referencesSoftwareAccountIdsLt,
                'references.software_account_ids.$lte': referencesSoftwareAccountIdsLte,
                'references.software_account_ids.$ne': referencesSoftwareAccountIdsNe,
                'references.software_account_ids.$nin': referencesSoftwareAccountIdsNin,
                'references.software_account_ids.$all': referencesSoftwareAccountIdsAll,
                'references.software_account_ids.$size': referencesSoftwareAccountIdsSize,
                'references.software_account_ids': referencesSoftwareAccountIds,
                'references.software_id.$exists': referencesSoftwareIdExists,
                'references.software_id.$eq': referencesSoftwareIdEq,
                'references.software_id.$gt': referencesSoftwareIdGt,
                'references.software_id.$gte': referencesSoftwareIdGte,
                'references.software_id.$in': referencesSoftwareIdIn,
                'references.software_id.$lt': referencesSoftwareIdLt,
                'references.software_id.$lte': referencesSoftwareIdLte,
                'references.software_id.$ne': referencesSoftwareIdNe,
                'references.software_id.$nin': referencesSoftwareIdNin,
                'references.software_id': referencesSoftwareId,
                'references.sub_account_id.$exists': referencesSubAccountIdExists,
                'references.sub_account_id.$eq': referencesSubAccountIdEq,
                'references.sub_account_id.$gt': referencesSubAccountIdGt,
                'references.sub_account_id.$gte': referencesSubAccountIdGte,
                'references.sub_account_id.$in': referencesSubAccountIdIn,
                'references.sub_account_id.$lt': referencesSubAccountIdLt,
                'references.sub_account_id.$lte': referencesSubAccountIdLte,
                'references.sub_account_id.$ne': referencesSubAccountIdNe,
                'references.sub_account_id.$nin': referencesSubAccountIdNin,
                'references.sub_account_id': referencesSubAccountId,
                'references': references,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Optimizations Savings
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getOptimizationsSavingsApiV1ManagementOptimizationsSavingsGet({
        hidden,
        tagsExists,
        tagsEq,
        tagsGt,
        tagsGte,
        tagsIn,
        tagsLt,
        tagsLte,
        tagsNe,
        tagsNin,
        tagsAll,
        tagsSize,
        tags,
        createdExists,
        createdEq,
        createdGt,
        createdGte,
        createdIn,
        createdLt,
        createdLte,
        createdNe,
        createdNin,
        created,
        updatedExists,
        updatedEq,
        updatedGt,
        updatedGte,
        updatedIn,
        updatedLt,
        updatedLte,
        updatedNe,
        updatedNin,
        updated,
        deleted,
        deletedAtExists,
        deletedAtEq,
        deletedAtGt,
        deletedAtGte,
        deletedAtIn,
        deletedAtLt,
        deletedAtLte,
        deletedAtNe,
        deletedAtNin,
        deletedAt,
        includeDeleted = false,
        idExists,
        idEq,
        idGt,
        idGte,
        idIn,
        idLt,
        idLte,
        idNe,
        idNin,
        id,
        typeExists,
        typeEq,
        typeGt,
        typeGte,
        typeIn,
        typeLt,
        typeLte,
        typeNe,
        typeNin,
        type,
        deprecated,
        referencesAccountIdExists,
        referencesAccountIdEq,
        referencesAccountIdGt,
        referencesAccountIdGte,
        referencesAccountIdIn,
        referencesAccountIdLt,
        referencesAccountIdLte,
        referencesAccountIdNe,
        referencesAccountIdNin,
        referencesAccountId,
        referencesDataSourceIdExists,
        referencesDataSourceIdEq,
        referencesDataSourceIdGt,
        referencesDataSourceIdGte,
        referencesDataSourceIdIn,
        referencesDataSourceIdLt,
        referencesDataSourceIdLte,
        referencesDataSourceIdNe,
        referencesDataSourceIdNin,
        referencesDataSourceId,
        referencesEmployeeIdExists,
        referencesEmployeeIdEq,
        referencesEmployeeIdGt,
        referencesEmployeeIdGte,
        referencesEmployeeIdIn,
        referencesEmployeeIdLt,
        referencesEmployeeIdLte,
        referencesEmployeeIdNe,
        referencesEmployeeIdNin,
        referencesEmployeeId,
        referencesSoftwareAccountIdExists,
        referencesSoftwareAccountIdEq,
        referencesSoftwareAccountIdGt,
        referencesSoftwareAccountIdGte,
        referencesSoftwareAccountIdIn,
        referencesSoftwareAccountIdLt,
        referencesSoftwareAccountIdLte,
        referencesSoftwareAccountIdNe,
        referencesSoftwareAccountIdNin,
        referencesSoftwareAccountId,
        referencesSoftwareAccountIdsExists,
        referencesSoftwareAccountIdsEq,
        referencesSoftwareAccountIdsGt,
        referencesSoftwareAccountIdsGte,
        referencesSoftwareAccountIdsIn,
        referencesSoftwareAccountIdsLt,
        referencesSoftwareAccountIdsLte,
        referencesSoftwareAccountIdsNe,
        referencesSoftwareAccountIdsNin,
        referencesSoftwareAccountIdsAll,
        referencesSoftwareAccountIdsSize,
        referencesSoftwareAccountIds,
        referencesSoftwareIdExists,
        referencesSoftwareIdEq,
        referencesSoftwareIdGt,
        referencesSoftwareIdGte,
        referencesSoftwareIdIn,
        referencesSoftwareIdLt,
        referencesSoftwareIdLte,
        referencesSoftwareIdNe,
        referencesSoftwareIdNin,
        referencesSoftwareId,
        referencesSubAccountIdExists,
        referencesSubAccountIdEq,
        referencesSubAccountIdGt,
        referencesSubAccountIdGte,
        referencesSubAccountIdIn,
        referencesSubAccountIdLt,
        referencesSubAccountIdLte,
        referencesSubAccountIdNe,
        referencesSubAccountIdNin,
        referencesSubAccountId,
        references,
        limit,
        offset,
        sortBy,
        sortOrder,
        sort,
        targetCurrencyCode = 'EUR',
        userCostIgnoreUnassignedQuota = false,
        xTransactionId,
    }: {
        hidden?: (boolean | null),
        tagsExists?: (boolean | null),
        tagsEq?: (string | null),
        tagsGt?: (string | null),
        tagsGte?: (string | null),
        tagsIn?: (Array<string> | null),
        tagsLt?: (string | null),
        tagsLte?: (string | null),
        tagsNe?: (string | null),
        tagsNin?: (Array<string> | null),
        tagsAll?: (Array<string> | null),
        tagsSize?: (number | null),
        tags?: (string | null),
        createdExists?: (boolean | null),
        createdEq?: (string | null),
        createdGt?: (string | null),
        createdGte?: (string | null),
        createdIn?: (Array<string> | null),
        createdLt?: (string | null),
        createdLte?: (string | null),
        createdNe?: (string | null),
        createdNin?: (Array<string> | null),
        created?: (string | null),
        updatedExists?: (boolean | null),
        updatedEq?: (string | null),
        updatedGt?: (string | null),
        updatedGte?: (string | null),
        updatedIn?: (Array<string> | null),
        updatedLt?: (string | null),
        updatedLte?: (string | null),
        updatedNe?: (string | null),
        updatedNin?: (Array<string> | null),
        updated?: (string | null),
        deleted?: (boolean | null),
        deletedAtExists?: (boolean | null),
        deletedAtEq?: (string | null),
        deletedAtGt?: (string | null),
        deletedAtGte?: (string | null),
        deletedAtIn?: (Array<string> | null),
        deletedAtLt?: (string | null),
        deletedAtLte?: (string | null),
        deletedAtNe?: (string | null),
        deletedAtNin?: (Array<string> | null),
        deletedAt?: (string | null),
        includeDeleted?: boolean,
        idExists?: (boolean | null),
        idEq?: (string | null),
        idGt?: (string | null),
        idGte?: (string | null),
        idIn?: (Array<string> | null),
        idLt?: (string | null),
        idLte?: (string | null),
        idNe?: (string | null),
        idNin?: (Array<string> | null),
        id?: (string | null),
        typeExists?: (boolean | null),
        typeEq?: (OptimizationType | null),
        typeGt?: (OptimizationType | null),
        typeGte?: (OptimizationType | null),
        typeIn?: (Array<OptimizationType> | null),
        typeLt?: (OptimizationType | null),
        typeLte?: (OptimizationType | null),
        typeNe?: (OptimizationType | null),
        typeNin?: (Array<OptimizationType> | null),
        type?: (OptimizationType | null),
        deprecated?: (boolean | null),
        referencesAccountIdExists?: (boolean | null),
        referencesAccountIdEq?: (string | null),
        referencesAccountIdGt?: (string | null),
        referencesAccountIdGte?: (string | null),
        referencesAccountIdIn?: (Array<string> | null),
        referencesAccountIdLt?: (string | null),
        referencesAccountIdLte?: (string | null),
        referencesAccountIdNe?: (string | null),
        referencesAccountIdNin?: (Array<string> | null),
        referencesAccountId?: (string | null),
        referencesDataSourceIdExists?: (boolean | null),
        referencesDataSourceIdEq?: (string | null),
        referencesDataSourceIdGt?: (string | null),
        referencesDataSourceIdGte?: (string | null),
        referencesDataSourceIdIn?: (Array<string> | null),
        referencesDataSourceIdLt?: (string | null),
        referencesDataSourceIdLte?: (string | null),
        referencesDataSourceIdNe?: (string | null),
        referencesDataSourceIdNin?: (Array<string> | null),
        referencesDataSourceId?: (string | null),
        referencesEmployeeIdExists?: (boolean | null),
        referencesEmployeeIdEq?: (string | null),
        referencesEmployeeIdGt?: (string | null),
        referencesEmployeeIdGte?: (string | null),
        referencesEmployeeIdIn?: (Array<string> | null),
        referencesEmployeeIdLt?: (string | null),
        referencesEmployeeIdLte?: (string | null),
        referencesEmployeeIdNe?: (string | null),
        referencesEmployeeIdNin?: (Array<string> | null),
        referencesEmployeeId?: (string | null),
        referencesSoftwareAccountIdExists?: (boolean | null),
        referencesSoftwareAccountIdEq?: (string | null),
        referencesSoftwareAccountIdGt?: (string | null),
        referencesSoftwareAccountIdGte?: (string | null),
        referencesSoftwareAccountIdIn?: (Array<string> | null),
        referencesSoftwareAccountIdLt?: (string | null),
        referencesSoftwareAccountIdLte?: (string | null),
        referencesSoftwareAccountIdNe?: (string | null),
        referencesSoftwareAccountIdNin?: (Array<string> | null),
        referencesSoftwareAccountId?: (string | null),
        referencesSoftwareAccountIdsExists?: (boolean | null),
        referencesSoftwareAccountIdsEq?: (string | null),
        referencesSoftwareAccountIdsGt?: (string | null),
        referencesSoftwareAccountIdsGte?: (string | null),
        referencesSoftwareAccountIdsIn?: (Array<string> | null),
        referencesSoftwareAccountIdsLt?: (string | null),
        referencesSoftwareAccountIdsLte?: (string | null),
        referencesSoftwareAccountIdsNe?: (string | null),
        referencesSoftwareAccountIdsNin?: (Array<string> | null),
        referencesSoftwareAccountIdsAll?: (Array<string> | null),
        referencesSoftwareAccountIdsSize?: (number | null),
        referencesSoftwareAccountIds?: (string | null),
        referencesSoftwareIdExists?: (boolean | null),
        referencesSoftwareIdEq?: (string | null),
        referencesSoftwareIdGt?: (string | null),
        referencesSoftwareIdGte?: (string | null),
        referencesSoftwareIdIn?: (Array<string> | null),
        referencesSoftwareIdLt?: (string | null),
        referencesSoftwareIdLte?: (string | null),
        referencesSoftwareIdNe?: (string | null),
        referencesSoftwareIdNin?: (Array<string> | null),
        referencesSoftwareId?: (string | null),
        referencesSubAccountIdExists?: (boolean | null),
        referencesSubAccountIdEq?: (string | null),
        referencesSubAccountIdGt?: (string | null),
        referencesSubAccountIdGte?: (string | null),
        referencesSubAccountIdIn?: (Array<string> | null),
        referencesSubAccountIdLt?: (string | null),
        referencesSubAccountIdLte?: (string | null),
        referencesSubAccountIdNe?: (string | null),
        referencesSubAccountIdNin?: (Array<string> | null),
        referencesSubAccountId?: (string | null),
        references?: null,
        limit?: (number | null),
        offset?: (number | null),
        /**
         * Field name to be sorted by. Ignored if 'sort' is specified
         */
        sortBy?: (string | null),
        /**
         * Sort order to be sorted by. Ignored if 'sort' is specified
         */
        sortOrder?: (PaginationSortOrder | null),
        /**
         * Sort field in the form `<field_name>:<sort_by>`. Example: `sort=email:asc`. If at least one is set, sort_by and sort_order are ignored
         */
        sort?: (Array<string> | null),
        targetCurrencyCode?: CurrencyCode,
        userCostIgnoreUnassignedQuota?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<Record<string, number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/management/optimizations/savings',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'hidden': hidden,
                'tags.$exists': tagsExists,
                'tags.$eq': tagsEq,
                'tags.$gt': tagsGt,
                'tags.$gte': tagsGte,
                'tags.$in': tagsIn,
                'tags.$lt': tagsLt,
                'tags.$lte': tagsLte,
                'tags.$ne': tagsNe,
                'tags.$nin': tagsNin,
                'tags.$all': tagsAll,
                'tags.$size': tagsSize,
                'tags': tags,
                'created.$exists': createdExists,
                'created.$eq': createdEq,
                'created.$gt': createdGt,
                'created.$gte': createdGte,
                'created.$in': createdIn,
                'created.$lt': createdLt,
                'created.$lte': createdLte,
                'created.$ne': createdNe,
                'created.$nin': createdNin,
                'created': created,
                'updated.$exists': updatedExists,
                'updated.$eq': updatedEq,
                'updated.$gt': updatedGt,
                'updated.$gte': updatedGte,
                'updated.$in': updatedIn,
                'updated.$lt': updatedLt,
                'updated.$lte': updatedLte,
                'updated.$ne': updatedNe,
                'updated.$nin': updatedNin,
                'updated': updated,
                'deleted': deleted,
                'deleted_at.$exists': deletedAtExists,
                'deleted_at.$eq': deletedAtEq,
                'deleted_at.$gt': deletedAtGt,
                'deleted_at.$gte': deletedAtGte,
                'deleted_at.$in': deletedAtIn,
                'deleted_at.$lt': deletedAtLt,
                'deleted_at.$lte': deletedAtLte,
                'deleted_at.$ne': deletedAtNe,
                'deleted_at.$nin': deletedAtNin,
                'deleted_at': deletedAt,
                'include_deleted': includeDeleted,
                '_id.$exists': idExists,
                '_id.$eq': idEq,
                '_id.$gt': idGt,
                '_id.$gte': idGte,
                '_id.$in': idIn,
                '_id.$lt': idLt,
                '_id.$lte': idLte,
                '_id.$ne': idNe,
                '_id.$nin': idNin,
                '_id': id,
                'type.$exists': typeExists,
                'type.$eq': typeEq,
                'type.$gt': typeGt,
                'type.$gte': typeGte,
                'type.$in': typeIn,
                'type.$lt': typeLt,
                'type.$lte': typeLte,
                'type.$ne': typeNe,
                'type.$nin': typeNin,
                'type': type,
                'deprecated': deprecated,
                'references.account_id.$exists': referencesAccountIdExists,
                'references.account_id.$eq': referencesAccountIdEq,
                'references.account_id.$gt': referencesAccountIdGt,
                'references.account_id.$gte': referencesAccountIdGte,
                'references.account_id.$in': referencesAccountIdIn,
                'references.account_id.$lt': referencesAccountIdLt,
                'references.account_id.$lte': referencesAccountIdLte,
                'references.account_id.$ne': referencesAccountIdNe,
                'references.account_id.$nin': referencesAccountIdNin,
                'references.account_id': referencesAccountId,
                'references.data_source_id.$exists': referencesDataSourceIdExists,
                'references.data_source_id.$eq': referencesDataSourceIdEq,
                'references.data_source_id.$gt': referencesDataSourceIdGt,
                'references.data_source_id.$gte': referencesDataSourceIdGte,
                'references.data_source_id.$in': referencesDataSourceIdIn,
                'references.data_source_id.$lt': referencesDataSourceIdLt,
                'references.data_source_id.$lte': referencesDataSourceIdLte,
                'references.data_source_id.$ne': referencesDataSourceIdNe,
                'references.data_source_id.$nin': referencesDataSourceIdNin,
                'references.data_source_id': referencesDataSourceId,
                'references.employee_id.$exists': referencesEmployeeIdExists,
                'references.employee_id.$eq': referencesEmployeeIdEq,
                'references.employee_id.$gt': referencesEmployeeIdGt,
                'references.employee_id.$gte': referencesEmployeeIdGte,
                'references.employee_id.$in': referencesEmployeeIdIn,
                'references.employee_id.$lt': referencesEmployeeIdLt,
                'references.employee_id.$lte': referencesEmployeeIdLte,
                'references.employee_id.$ne': referencesEmployeeIdNe,
                'references.employee_id.$nin': referencesEmployeeIdNin,
                'references.employee_id': referencesEmployeeId,
                'references.software_account_id.$exists': referencesSoftwareAccountIdExists,
                'references.software_account_id.$eq': referencesSoftwareAccountIdEq,
                'references.software_account_id.$gt': referencesSoftwareAccountIdGt,
                'references.software_account_id.$gte': referencesSoftwareAccountIdGte,
                'references.software_account_id.$in': referencesSoftwareAccountIdIn,
                'references.software_account_id.$lt': referencesSoftwareAccountIdLt,
                'references.software_account_id.$lte': referencesSoftwareAccountIdLte,
                'references.software_account_id.$ne': referencesSoftwareAccountIdNe,
                'references.software_account_id.$nin': referencesSoftwareAccountIdNin,
                'references.software_account_id': referencesSoftwareAccountId,
                'references.software_account_ids.$exists': referencesSoftwareAccountIdsExists,
                'references.software_account_ids.$eq': referencesSoftwareAccountIdsEq,
                'references.software_account_ids.$gt': referencesSoftwareAccountIdsGt,
                'references.software_account_ids.$gte': referencesSoftwareAccountIdsGte,
                'references.software_account_ids.$in': referencesSoftwareAccountIdsIn,
                'references.software_account_ids.$lt': referencesSoftwareAccountIdsLt,
                'references.software_account_ids.$lte': referencesSoftwareAccountIdsLte,
                'references.software_account_ids.$ne': referencesSoftwareAccountIdsNe,
                'references.software_account_ids.$nin': referencesSoftwareAccountIdsNin,
                'references.software_account_ids.$all': referencesSoftwareAccountIdsAll,
                'references.software_account_ids.$size': referencesSoftwareAccountIdsSize,
                'references.software_account_ids': referencesSoftwareAccountIds,
                'references.software_id.$exists': referencesSoftwareIdExists,
                'references.software_id.$eq': referencesSoftwareIdEq,
                'references.software_id.$gt': referencesSoftwareIdGt,
                'references.software_id.$gte': referencesSoftwareIdGte,
                'references.software_id.$in': referencesSoftwareIdIn,
                'references.software_id.$lt': referencesSoftwareIdLt,
                'references.software_id.$lte': referencesSoftwareIdLte,
                'references.software_id.$ne': referencesSoftwareIdNe,
                'references.software_id.$nin': referencesSoftwareIdNin,
                'references.software_id': referencesSoftwareId,
                'references.sub_account_id.$exists': referencesSubAccountIdExists,
                'references.sub_account_id.$eq': referencesSubAccountIdEq,
                'references.sub_account_id.$gt': referencesSubAccountIdGt,
                'references.sub_account_id.$gte': referencesSubAccountIdGte,
                'references.sub_account_id.$in': referencesSubAccountIdIn,
                'references.sub_account_id.$lt': referencesSubAccountIdLt,
                'references.sub_account_id.$lte': referencesSubAccountIdLte,
                'references.sub_account_id.$ne': referencesSubAccountIdNe,
                'references.sub_account_id.$nin': referencesSubAccountIdNin,
                'references.sub_account_id': referencesSubAccountId,
                'references': references,
                'limit': limit,
                'offset': offset,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'sort': sort,
                'target_currency_code': targetCurrencyCode,
                'user_cost_ignore_unassigned_quota': userCostIgnoreUnassignedQuota,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Single Optimization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getSingleOptimizationApiV1ManagementOptimizationsOptimizationIdGet({
        optimizationId,
        xTransactionId,
    }: {
        optimizationId: string,
        xTransactionId?: (string | null),
    }): CancelablePromise<(OptimizationEmployeeLeaving | OptimizationSoftwareAccountDuplicate | OptimizationSoftwareAccountRedundantLicense | OptimizationSoftwareAccountUnused | OptimizationRightsizing)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/management/optimizations/{optimization_id}',
            path: {
                'optimization_id': optimizationId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Optimization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteOptimizationApiV1ManagementOptimizationsOptimizationIdDelete({
        optimizationId,
        xTransactionId,
    }: {
        optimizationId: string,
        xTransactionId?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/management/optimizations/{optimization_id}',
            path: {
                'optimization_id': optimizationId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Optimization Savings
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getOptimizationSavingsApiV1ManagementOptimizationsOptimizationIdSavingsGet({
        optimizationId,
        targetCurrencyCode = 'EUR',
        userCostIgnoreUnassignedQuota = false,
        xTransactionId,
    }: {
        optimizationId: string,
        targetCurrencyCode?: CurrencyCode,
        userCostIgnoreUnassignedQuota?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/management/optimizations/{optimization_id}/savings',
            path: {
                'optimization_id': optimizationId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'target_currency_code': targetCurrencyCode,
                'user_cost_ignore_unassigned_quota': userCostIgnoreUnassignedQuota,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Hide Optimization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static hideOptimizationApiV1ManagementOptimizationsOptimizationIdHidePost({
        optimizationId,
        xTransactionId,
    }: {
        optimizationId: string,
        xTransactionId?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/management/optimizations/{optimization_id}/hide',
            path: {
                'optimization_id': optimizationId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unhide Optimization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unhideOptimizationApiV1ManagementOptimizationsOptimizationIdUnhidePost({
        optimizationId,
        xTransactionId,
    }: {
        optimizationId: string,
        xTransactionId?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/management/optimizations/{optimization_id}/unhide',
            path: {
                'optimization_id': optimizationId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Execute
     * @returns any Successful Response
     * @throws ApiError
     */
    public static executeApiV1ManagementOptimizationsOptimizationIdExecutePost({
        optimizationId,
        xTransactionId,
    }: {
        optimizationId: string,
        xTransactionId?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/management/optimizations/{optimization_id}/execute',
            path: {
                'optimization_id': optimizationId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
